import $ from 'jquery';

export default class {
    constructor(el) {
        this.dom = {
            el: el,
            form: el,
            container: document.querySelector('[data-filtering="download"]'),
            apply: document.querySelector('[data-js="apply"]'),
        }

        this.input = {
            trigger: this.dom.el.querySelectorAll('input[type="radio"][id^="term-"]'),
            ppp: this.dom.el.querySelector('input[name="ppp"]'),
        }

        this.timer = null;
        this.jqxhr = null;
        this.res = null;

        this.init();
    }

    init() {
        const _this = this;
        // termチェックボックスイベント
        this.input.trigger.forEach(function(elm) {
            elm.addEventListener('click', e => {
                _this.dom.apply.click();
            });
        });
        this.dom.form.addEventListener('submit', this.formSubmit.bind(this));
    }

    formSubmit(e) {
        const _this = this;
        e.preventDefault();
        
        let filter = $(this.dom.el);
        if ( this.jqxhr ) this.jqxhr.abort();
        if ( this.timer ) clearTimeout(this.timer);

        this.jqxhr = $.ajax({
            url: filter.attr('action'),
            data: filter.serialize(), // form data
            type: filter.attr('method'), // POST
        })
        .done( function( res ) {
            // console.log('res', res);
        })
        .fail( function() {
            // console.log('fail');
        })
        .always( function( res ) {
            // console.log('res', res);
            _this.res = res;

            _this.hideAnim();
            _this.jqxhr = null;
        });
    }
    
    hideAnim() {
        const _this = this;
        
        while (_this.dom.container.firstChild) {
            _this.dom.container.removeChild(_this.dom.container.firstChild)
        }
        _this.appendElms(_this.res);
    }

    appendElms(_res) {
        const _this = this;
        [..._this.htmlToNode(_res)].forEach(elms => {
            _this.dom.container.appendChild(elms);
        });
    }

    htmlToNode(htmlStr) {
        if (!htmlStr || typeof htmlStr !== 'string') return;
        let tmpElmt = document.createElement('div'), i = 0, len = 0, nodes = [];
        // 高速処理するが対応ブラウザを考えinnerHTMLを使用
        tmpElmt.innerHTML = htmlStr; // tmpElmt.insertAdjacentHTML('beforeend', htmlStr);
        return tmpElmt.childNodes;
    }
}